module.exports = __webpack_public_path__ + "assets/img/24_422_big.d24bd66e.jpg";